module.exports = __webpack_public_path__ + "img/email-template.69ec8b53.png";